/**
 * Shared constants for Employee Create / Edit forms.
 * Extracted from EmployeeCreatePage.jsx and EmployeeEditPage.jsx
 * so both pages stay in sync — change once, applies everywhere.
 */

// Validation regex patterns
export const PATTERNS = {
  saudiNationalId: /^1\d{9}$/,
  iqama: /^2\d{9}$/,
  saudiIBAN: /^SA\d{2}[A-Z0-9]{20}$/,
  email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  saudiMobile: /^(05|5|009665|\+9665)\d{8}$/,
};

export const STATUSES = [
  { value: 'active', label: { en: 'Active', ar: 'نشط' } },
  { value: 'on_leave', label: { en: 'On Leave', ar: 'في إجازة' } },
  { value: 'suspended', label: { en: 'Suspended', ar: 'موقوف' } },
  { value: 'terminated', label: { en: 'Terminated', ar: 'منتهي' } },
  { value: 'resigned', label: { en: 'Resigned', ar: 'مستقيل' } },
];

export const CONTRACT_TYPES = [
  { value: 'permanent', label: { en: 'Permanent', ar: 'دائم' } },
  { value: 'temporary', label: { en: 'Temporary', ar: 'مؤقت' } },
  { value: 'contract', label: { en: 'Contract', ar: 'عقد' } },
  { value: 'probation', label: { en: 'Probation', ar: 'تحت التجربة' } },
];

export const GENDERS = [
  { value: 'male', label: { en: 'Male', ar: 'ذكر' } },
  { value: 'female', label: { en: 'Female', ar: 'أنثى' } },
];

// Legacy fallback list (used only if the departments API returns nothing)
export const DEPARTMENTS = [
  'Human Resources',
  'Finance',
  'IT',
  'Operations',
  'Marketing',
  'Sales',
  'Engineering',
  'Legal',
  'Administration',
];

export const BANKS = [
  'Al Rajhi Bank',
  'The National Commercial Bank (NCB)',
  'Riyad Bank',
  'Saudi British Bank (SABB)',
  'Banque Saudi Fransi',
  'Arab National Bank',
  'Alinma Bank',
  'Bank AlJazira',
  'Bank Albilad',
  'Saudi Investment Bank',
];
